import { useCallback, useEffect, useMemo, useState } from 'react';
import { usePublicSettings } from '../context/PublicSettingsContext.js';
import { useStorefront } from '../context/StoreContext.js';
import { resolveMediaUrl } from '../utils/mediaUrl.js';
import fallbackLogo from '../assets/img/your-logo-here-placeholder-primary-color.svg';


function buildLogoCandidates(publicSettings, organization) {
    return [
        resolveMediaUrl(publicSettings?.logoUrl),
        resolveMediaUrl(organization?.settings?.logoUrl),
        fallbackLogo,
    ].filter(Boolean);
}

export function useStoreLogo() {
    const { publicSettings } = usePublicSettings();
    const { organization, store } = useStorefront();

    const candidates = useMemo(
        () => buildLogoCandidates(publicSettings, organization),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [publicSettings?.logoUrl, organization?.settings?.logoUrl]
    );

    const [activeIndex, setActiveIndex] = useState(0);

    useEffect(() => {
        setActiveIndex(0);
    }, [publicSettings?.logoUrl, organization?.settings?.logoUrl]);

    const handleError = useCallback(() => {
        setActiveIndex((current) => {
            if (current >= candidates.length - 1) return current;
            return current + 1;
        });
    }, [candidates.length]);

    const src = candidates[activeIndex] || fallbackLogo;
    const alt =
        publicSettings?.businessName ||
        organization?.name ||
        store?.name ||
        'Quazbit';

    return {
        src,
        alt,
        onError: handleError,
        isRemote: src !== fallbackLogo,
    };
}
